'use strict';
import util from '../../util';
import miniCart from '../..//minicart';
import analytics from '../../analytics';

const basketProductLineItems = {};
let previousActiveElement = null;

var dialogSDK = {
    initPDP: async function () {
        const $dialogInput = $('.dialog-ask-anything-input');
        const $sendMessageButton = $('#send-message-button');
        const $masterID = $('.product-info .selected .swatchanchor').data('mpid') || $('.pdp-main').data('pid') && $('.pdp-main').data('pid').toString();
        const $selectedID = $('.product-info .selected .swatchanchor').data('pid') ? $('.product-info .selected .swatchanchor').data('pid').toString() : '' || $('.pdp-main').data('pid') && $('.pdp-main').data('pid').toString();
        const $prodName = $('.product-details-wrapper .product-name') ? $('.product-details-wrapper .product-name').text().trim() : '';

        $dialogInput.on("input", function () {
            if ($.trim($dialogInput.val()) !== '') {
                $sendMessageButton.prop('disabled', false);
            } else {
                $sendMessageButton.prop('disabled', true);
            }
        });

        try {
            const dialogClient = createDialogClient();
            const aiSuggestions = await fetchProductSuggestions(dialogClient, $masterID);
            if (aiSuggestions.questions.length < 1) {
                overrideDefaultQuestions(aiSuggestions);
            }
            renderAISuggestions(aiSuggestions, dialogClient);
            // send message gtm event for input field available inside dialog
            dialogClient.onAssistantEvent((event) => {
                switch (event.type) {
                    case 'userSentMessage':
                        if ($("#dialog-ai-input").val() != undefined && $dialogInput.val() == "") {
                            analytics.sendAIDialogMessage();
                            $("#dialog-ai-input").val("");
                        }
                        break;
                }
            });

            $sendMessageButton.on('click', function () {
                dialogClient.sendProductMessage({
                    question: $dialogInput.val(),
                    selectedVariantId: $selectedID,
                    productId: $masterID,
                    productTitle: $prodName
                });
                // send message gtm event for input field available on pdp page
                analytics.sendAIDialogMessage();
                $dialogInput.val("");
                accessibilitySetKeepFocusInside();
            });

            $dialogInput.on('keydown', function (e) {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    $sendMessageButton.trigger('click');
                    accessibilitySetKeepFocusInside();
                }
            });
        } catch (error) {
            console.error('Failed to load AI suggestions:', error);
        }

        /**
         * Fetches AI-generated suggestions for a product
         */
        async function fetchProductSuggestions(dialogClient, productId) {
            return await dialogClient.getSuggestions(productId);
        }

        /**
         * Fallback questions if no suggestions are available
         */
        function overrideDefaultQuestions(suggestionsData) {
            suggestionsData.questions = [
                {
                    question: "What is the formula used in this repairing gel to soothe the skin after sun exposure?"
                },
                {
                    question: "How does this gel relieve sunburn and reduce pain?"
                },
                {
                    question: "What are the benefits for the skin after using this product following excessive exposure to UV rays?"
                }
            ];
        }

        /**
         * Renders assistant metadata and interactive suggestions
         */
        function renderAISuggestions(suggestionsData, dialogClient) {
            const $dialogInstantElement = $('#dialog-instant');
            const $assistantNameElement = $('#assistant-name');
            const $descriptionElement = $('#suggestions-description');
            const $suggestionsContainer = $('#dialog-suggestions-container');
            const $inputElement = $('.dialog-input-container input');

            $dialogInstantElement.css('display', 'flex');

            if ($assistantNameElement.length) {
                $assistantNameElement.text(suggestionsData.assistantName);
            }

            if ($descriptionElement.length) {
                $descriptionElement.text(suggestionsData.description);
            }

            if ($inputElement.length) {
                $inputElement.attr('placeholder', suggestionsData.inputPlaceholder);
            }

            suggestionsData.questions.forEach((questionObj) => {
                const $button = $(createSuggestionButton(questionObj.question, dialogClient));
                $suggestionsContainer.append($button);
            });
        }

        /**
         * Creates a clickable suggestion button
         */
        function createSuggestionButton(questionText, dialogClient) {
            const $button = $('<button>', { class: 'dialog-suggestion' });
            const $icon = $('<img>', {
                src: window.Urls.starsImage,
                alt: 'stars icon'
            });
            const $label = $('<span>').text(questionText);

            $button.append($icon, $label);

            $button.on('click', function () {
                dialogClient.sendProductMessage({
                    question: questionText,
                    selectedVariantId: $selectedID,
                    productId: $masterID,
                    productTitle: $prodName
                });
                accessibilitySetKeepFocusInside();
            });

            return $button[0];
        }
    },
    init: function () {
        // HP-specific initialization
        initCommonPage();
        toggleQuickQuestions();
    }
};

const accessibilitySetKeepFocusInside = () => {
    setTimeout(() => {
        previousActiveElement = document.activeElement;
        accessibility.setKeepFocusInside(document.querySelector('#dialog-ai-chat-panel'), true);
        restoreFocusAfterDialogClose();
    }, 2000);
}

const toggleQuickQuestions = () => {
    let openTimer;
    let closeTimer;
    let keyboardOpened = false;
    const inertElements = new Map();
    const HOVER_DELAY = 200;
    const $body = $('body');
    const $trigger = $('.dialog-ai-header-btn');
    const $panel = $('#dialog-ai-quick-questions');
    const $overlay = $('.dialog-overlay');
    let $stateAnnouncement = $trigger.siblings('.dialog-ai-state-announcement');
    const $navContainer = $('.nav-container.main-nav-container');

    if (!$stateAnnouncement.length) {
        $stateAnnouncement = $('<span>', {
            class: 'sr-only dialog-ai-state-announcement',
            'aria-live': 'polite',
            'aria-atomic': 'true'
        }).insertAfter($trigger);
    }

    $trigger.removeAttr('aria-label aria-labelledby');
    $trigger.find('svg').attr({ 'aria-hidden': 'true', focusable: 'false' });

    const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;

    const setBackgroundInert = (inert) => {
        if (!inert) {
            inertElements.forEach((wasInert, element) => {
                element.inert = wasInert;
            });
            inertElements.clear();
            return;
        }

        let current = $panel[0];
        while (current && current !== document.body) {
            Array.from(current.parentElement.children).forEach((sibling) => {
                if (sibling === current || sibling.matches('.dialog-overlay') ||
                    sibling.contains(document.querySelector('#dialog-ai-chat-panel'))) return;

                if (!inertElements.has(sibling)) {
                    inertElements.set(sibling, sibling.inert);
                }
                sibling.inert = true;
            });
            current = current.parentElement;
        }
    };

    const setPanelState = (open, modal = false) => {
        const wasOpen = $trigger.attr('aria-expanded') === 'true';
        $trigger.attr('aria-expanded', String(open));
        $panel.attr('aria-hidden', String(!open));
        if (isDesktop() && wasOpen !== open && document.activeElement !== $trigger[0]) {
            const triggerLabel = $trigger.find('span').first().text().trim() || $trigger.text().trim();
            $stateAnnouncement.text(triggerLabel + ', ' + (open ? 'expanded' : 'collapsed'));
        }
        if (modal) {
            $panel.attr({ role: 'dialog', 'aria-modal': 'true' });
        } else {
            $panel.removeAttr('role aria-modal');
        }
        if (open) {
            $panel.removeAttr('inert');
        } else {
            $panel.attr('inert', '');
        }
    };

    const openQuickQuestions = ({ keyboard = false, modal = false } = {}) => {
        clearTimeout(closeTimer);
        console.log('Opening quick questions'), console.log('Keyboard opened:', keyboard);
        keyboardOpened = keyboard;
        setPanelState(true, modal);
        $panel.removeClass('hide').stop(true, true);

        if (modal) {
            $('html').addClass('modal-open');
            $overlay.addClass('show');
            setBackgroundInert(true);
            $panel.stop(true, true).slideDown(200);
            $panel.find('.dialog-ai-close-btn').trigger('focus');
        } else if (keyboardOpened) {
            const $firstQuestion = $panel.find('.dialog-suggestion:visible').first();
            $firstQuestion.trigger('focus');
            if ($firstQuestion.length) {
                window.setTimeout(() => {
                    if ($trigger.attr('aria-expanded') === 'true') {
                        const triggerLabel = $trigger.find('span').first().text().trim() || $trigger.text().trim();
                        $stateAnnouncement.text(triggerLabel + ', expanded');
                    }
                }, 0);
            }
        }
    };

    const closeQuickQuestions = ({ restoreFocus = true, modal = !isDesktop() } = {}) => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        keyboardOpened = false;
        setPanelState(false);

        if (modal) {
            setBackgroundInert(false);
            $('html').removeClass('modal-open');
            $overlay.removeClass('show');
            $panel.stop(true, true).slideUp(200, () => $panel.addClass('hide'));
        } else {
            $panel.addClass('hide');
        }

        if (restoreFocus && $trigger.length) $trigger[0].focus({ preventScroll: true });
    };

    const scheduleOpen = () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => openQuickQuestions(), HOVER_DELAY);
    };

    const scheduleClose = () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
            if (keyboardOpened || $panel.find(':focus').length || $('.dialog-ai-disclosure:hover').length) return;
            closeQuickQuestions({ restoreFocus: false, modal: false });
        }, HOVER_DELAY);
    };

    const activateTrigger = (keyboard) => {
        if (isDesktop()) {
            if ($trigger.attr('aria-expanded') === 'true') {
                closeQuickQuestions({ modal: false });
            } else {
                openQuickQuestions({ keyboard, modal: false });
            }
        } else if ($trigger.attr('aria-expanded') === 'true') {
            closeQuickQuestions({ modal: true });
        } else {
            previousActiveElement = $trigger[0];
            openQuickQuestions({ keyboard, modal: true });
        }
    };

    $body.off('.quickQuestions');
    $body
        .on('mouseenter.quickQuestions', '.dialog-ai-header-btn', () => {
            if (isDesktop()) scheduleOpen();
        })
        .on('mouseleave.quickQuestions', '.dialog-ai-header-btn', () => {
            if (isDesktop()) scheduleClose();
        })
        .on('mouseleave.quickQuestions', '.dialog-ai-disclosure', () => {
            if (isDesktop()) scheduleClose();
        })
        .on('mouseenter.quickQuestions', '#dialog-ai-quick-questions', () => clearTimeout(closeTimer))
        .on('mouseleave.quickQuestions', '#dialog-ai-quick-questions', () => {
            if (isDesktop()) scheduleClose();
        })
        .on('keydown.quickQuestions', '.dialog-ai-header-btn', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
            event.preventDefault();
            const keyboard = true;
            activateTrigger(keyboard);
        })
        .on('click.quickQuestions', '.dialog-ai-header-btn', (event) => {
            const keyboard = event.originalEvent && event.originalEvent.detail === 0;
            if (isDesktop() && !keyboard) return;
            activateTrigger(keyboard);
        })
        .on('closeDialogAIQuickQuestions.quickQuestions', () => {
            closeQuickQuestions({ modal: !isDesktop() });
        })
        .on('click.quickQuestions', '.dialog-ai-close-btn, .dialog-overlay', (event) => {
            event.preventDefault();
            if (!isDesktop()) closeQuickQuestions({ modal: true });
        })
        .on('keydown.quickQuestions', (event) => {
            if (event.key === 'Escape' && $trigger.attr('aria-expanded') === 'true') {
                event.preventDefault();
                closeQuickQuestions({ modal: !isDesktop() });
            }
        })
        .on('keydown.quickQuestions', '#dialog-ai-quick-questions', (event) => {
            if (isDesktop() || event.key !== 'Tab') return;
            const $focusable = $panel.find('button:visible:not(:disabled)');
            const first = $focusable[0];
            const last = $focusable[$focusable.length - 1];

            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        })
        .on('keydown.quickQuestions', '#dialog-ai-suggestions .dialog-suggestion', (event) => {
            const lastQuestion = $panel.find('.dialog-suggestion').last()[0];
            if (!isDesktop() || event.key !== 'Tab' || event.shiftKey || event.currentTarget !== lastQuestion) return;
            setTimeout(() => closeQuickQuestions({ restoreFocus: false, modal: false }), 0);
        });

    window.matchMedia('(min-width: 1024px)').addEventListener('change', () => {
        if ($trigger.attr('aria-expanded') === 'true') {
            setBackgroundInert(false);
            $('html').removeClass('modal-open');
            $overlay.removeClass('show');
            $panel.stop(true, true).addClass('hide');
            setPanelState(false);
            $trigger.trigger('focus');
        }
    });
};

// Initializes the Dialog client with callbacks
function createDialogClient() {
    return new window.DialogSDK.Dialog({
        apiKey: SitePreferences.DIALOG_SCRIPT_API,
        locale: window.User.locale.split("_")[0],
        theme: {
            primaryColor: 'rgba(214, 0, 28, 0.50)',
            ctaTextColor: '#ffffff',
            fontFamily: 'GinzaRegular, Arial, sans-serif'
        },
        callbacks: {
            addToCart: async ({ productId, quantity, currency, variantId }) => {
                const csrfToken = $('meta[name="csrf-token"]').attr('content');
                const formData = new FormData();
                const productIdentifier = variantId || productId;

                formData.append('pid', productIdentifier);
                formData.append('format', 'ajax');
                formData.append(Constants.CSRF_TOKEN_NAME, csrfToken);
                formData.append('Quantity', quantity || 1);

                try {
                    const response = await fetch(window.Urls.addProduct, {
                        method: 'POST',
                        body: formData
                    });

                    const contentType = response.headers.get('content-type');

                    let productData;

                    if (contentType && contentType.includes('application/json')) {
                        productData = await response.json();

                        if (!productData.success) {
                            console.error('Failed to add product:', productData);
                            throw new Error(productData.message || 'Server responded with an error');
                        }
                        console.warn('Received JSON response instead of HTML. Not rendering mini cart.');
                    } else {
                        productData = await response.text();

                        if (!response.ok) {
                            console.error('Failed to add product:', productData);
                            throw new Error('Server responded with an error');
                        }
                        basketProductLineItems[productIdentifier] = productIdentifier;
                        miniCart.show(productData);
                        let dialogVariantColor = $("#dialog-drawer #Colour").val();
                        let dialogVariantSize = $("#dialog-drawer #Size").val();

                        if ($('.pdp-page').length > 0) {
                            analytics.addProductAIDialogPDP(dialogVariantColor, dialogVariantSize);
                        } else {
                            analytics.addProductAIDialog(productId, quantity, variantId);
                        }

                        // selected variant product price

                        var price;
                        if ($('#dialog-drawer span').length > 0) {
                            price = $('#dialog-drawer span:last-child').filter(function () {
                                return /[\p{Sc}]\s?[\d]/u.test($(this).text());
                            }).first().text().trim().replace(/[^\d.,]/g, '');
                        }
                        else {
                            price = $('#dialog-ai-container span:last-child').filter(function () {
                                return /[\p{Sc}]\s?[\d]/u.test($(this).text());
                            }).first().text().trim().replace(/[^\d.,]/g, '');
                        }

                        const addToCartObj = analytics.trackCartAddition(productId, quantity, currency, price, variantId);

                        if (window.dialog && window.dialog.instance) {
                            window.dialog.instance.registerAddToCartEvent(addToCartObj);
                        }

                        setTimeout(function () {
                            $('html').removeClass('modal-open');
                        }, 1000);
                    }

                } catch (error) {
                    console.error('Could not add item to cart. Please try again later.', error);
                }
            },

            getProduct: async (productId, variantId) => {
                const productUrl = util.appendParamToURL(window.Urls.getProductDetails, 'pid', variantId);

                try {
                    const response = await fetch(productUrl, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json;charset=UTF-8'
                        }
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const productData = await response.json();
                    return productData;
                } catch (error) {
                    console.log('Could not find any item. Please try again later.' + error);
                }
            }
        }
    });
}

// Handles user sent message event to trigger analytics and clear input
const handleUserSentMessage = (event) => {
    if (event.type !== 'userSentMessage') {
        return;
    }

    const $aiInput = $('#dialog-ai-input');
    if ($aiInput.val() !== undefined) {
        analytics.sendAIDialogMessage();
        $aiInput.val('');
    }
};

const restoreFocusAfterDialogClose = () => {
    const waitForClose = (startedAt) => {
        const $dialog = $('#dialog-ai-chat-panel');
        if ($dialog.length && $dialog.is(':visible') && Date.now() - startedAt < 3000) {
            window.requestAnimationFrame(() => waitForClose(startedAt));
            return;
        }
        // Ensure the dialog is no longer visible before restoring focus
        // ESC to close dialog
        $dialog.on('keydown', function (e) {
            if (e.key === 'Escape') {
                e.preventDefault();
                setTimeout(() => {
                    // Trigger your close button
                const $closeBtn = $dialog.find('button[aria-label="Close"]');
                if ($closeBtn.length) {
                    $closeBtn.trigger('click');
                    if (previousActiveElement) {
                        previousActiveElement.focus();
                        previousActiveElement = null;
                    }
                }
                }, 1000);    
                
            }
        });

        $dialog.find('button[aria-label="Close"]').on('keydown', function (e) {
            // e.stopPropagation();
            if (e.key === 'Enter') {
                const $focused = $(document.activeElement);
                if ($focused.attr('aria-label') === 'Close') {
                    setTimeout(() => {
                        if (previousActiveElement) {
                            previousActiveElement.focus();
                            previousActiveElement = null;
                        }
                    }, 1000);
                }
            }
        });
    
    };

    window.requestAnimationFrame(() => waitForClose(Date.now()));
};

// Binds click events to suggestion buttons to send messages to the dialog
const bindSuggestionButtons = (dialogClient) => {
    $('#dialog-suggestions-container .dialog-suggestion, #dialog-ai-suggestions .dialog-suggestion').each(function () {
        const $button = $(this);
        const questionText = $button.find('.dialog-ai-question-title').text().trim() || $button.text().trim();
        const type = $button.data('type');
        const buttonText = $button.text().replace(/\s+/g, ' ').trim();
        const describedBy = ($button.attr('aria-describedby') || '').split(/\s+/).filter(Boolean);
        const remainingDescriptions = describedBy.filter((id) => {
            const description = document.getElementById(id);
            const descriptionText = description ? description.textContent.replace(/\s+/g, ' ').trim() : '';
            return !descriptionText || !buttonText.includes(descriptionText);
        });

        if (remainingDescriptions.length) {
            $button.attr('aria-describedby', remainingDescriptions.join(' '));
        } else if (describedBy.length) {
            $button.removeAttr('aria-describedby');
        }

        const handleAction = () => {
            const $headerTrigger = $('.dialog-ai-header-btn');
            if ($headerTrigger.length) previousActiveElement = $headerTrigger[0];
            $('body').trigger('closeDialogAIQuickQuestions');

            accessibilitySetKeepFocusInside();

            if (type === 'personal-shopper') {
                const personalShopperId = $button
                    .closest('.dialog-container, .dialog-ai-wrapper')
                    .attr('data-id');

                window.dispatchEvent(
                    new CustomEvent('enableDialogAssistantEvent', {
                        detail: {
                            type: 'START_DIAGNOSTIC',
                            payload: {
                                buttonType: 'SIMPLE_BUTTON_DIAGNOSTIC',
                                personalShopperId: personalShopperId
                            }
                        }
                    })
                );
            } else {
                dialogClient.sendProductMessage({ question: questionText });
            }
        };

        $button.on('click', handleAction);
    });
};

// Initializes the Dialog client, fetches suggestions, and sets up the UI
const initCommonPage = async () => {
    try {
        const dialogClient = createDialogClient();
        bindSuggestionButtons(dialogClient);
        dialogClient.onAssistantEvent(handleUserSentMessage);
    } catch (error) {
        console.error('Failed to load AI suggestions:', error);
    }
};

const dialogSDKInit = () => {
    const isDialogEnabled = SitePreferences.DIALOG_SCRIPT_ENABLED;
    const isPDP = $('.pdp-page').length;
    const isCheckout = $('.checkout_page').length;
    const hasDialogContainer = $('.dialog-ai-container').length;

    if (!isDialogEnabled) {
        return;
    }

    if (isPDP) {
        dialogSDK.initPDP();
        dialogSDK.init();
    } else if (hasDialogContainer) {
        dialogSDK.init();
    } else if (!isCheckout) {
        createDialogClient();
    }
}

export default dialogSDKInit;
export { dialogSDK };